'use client';

import { useEffect } from 'react';
import { ddRumAction } from '@/utils/datadog';
import { TIMERS_IN_MS } from '@/utils/constants';

const DLC_USER_AGENT = 'FDPoker';
const DEFAULT_TIMEOUT_MS = TIMERS_IN_MS.ONE_MINUTE * 10;
const BLANK_URL = 'about:blank';

export type UseDlcAutoCloseOptions = {
    name: string;
    description: string;
    timeoutMs?: number;
};

export const useDlcAutoClose = ({ name, description, timeoutMs = DEFAULT_TIMEOUT_MS }: UseDlcAutoCloseOptions) => {
    useEffect(() => {
        if (typeof navigator === 'undefined' || !navigator.userAgent.includes(DLC_USER_AGENT)) {
            return;
        }

        const timeoutId = window.setTimeout(() => {
            ddRumAction({
                name,
                description,
                use_case: 'GLOBAL'
            });

            window.location.href = BLANK_URL;
        }, timeoutMs);

        return () => window.clearTimeout(timeoutId);
    }, [name, description, timeoutMs]);
};
